window.IMask = require('imask').default

let Module = {
    name: 'zip',
    misc: {
        phoneCodesSimplified: require('../misc/zip-codes-simplified.json')
    },
    selectors: {
        input: '#zip'
    },

    init: function () {
        let zipInput = $(Module.selectors.input);
        if (zipInput.length === 0) {
            return;
        }

        if (zipInput.data('country-code')) {
            Module.setMask(Module.selectors.input, zipInput.data('country-code'));
        }

        $(document).on('countries:init', function (e) {
            Module.setMask(Module.selectors.input, e.countryData.code);
        })

        $(document).on('countries:changed', function (e) {
            zipInput.val('');
            zipInput.data('value', '');
            Module.setMask(Module.selectors.input, e.countryData.code);
        })

        // change country in the profile change subscription modal
        if (zipInput.data('subsc-id')) {
            $(document).on('ProfileCountrySelect_' + zipInput.data('subsc-id') + ':changed', function (e) {
                zipInput.val('');
                zipInput.data('value', '');
                Module.setMask(Module.selectors.input, e.countryData.code);
            })
        }
    },

    setMask: function (selector, countryCode) {
        $(Module.selectors.input + ' + label').removeClass('notEmpty');

        if (this.maskObj) this.maskObj.destroy();
        let mask = Module.misc.phoneCodesSimplified[countryCode];
        if (mask === undefined) {
            return;
        }

        if(mask === null) {
            $(Module.selectors.input).prop('name', 'zip_optional');
            return;
        } else {
            $(Module.selectors.input).prop('name', 'zip');
        }

        let maskData = [];
        if(Array.isArray(mask)) {
            mask.forEach((maskItem) => {
                maskData.push({
                    mask: maskItem,
                });
            })
        } else {
            maskData = mask;
        }

        if (!Array.isArray(mask)) {
            $(Module.selectors.input + ' + label').addClass('notEmpty');
        }

        let maskOptions = {
            mask: maskData,
            overwrite: true,
            autofix: true,
            placeholderChar: '_',
            lazy: false,
        };
        
        let element = document.querySelector(selector);
        element.value = $(element).data().value ?? '';

        let maskObj = IMask(element, maskOptions);
        maskObj.updateValue('');
        this.maskObj = maskObj;
    },
}

module.exports = Module
